module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classObject
  }, [(_vm.shouldShowLabel) ? _c('span', {
    staticClass: "vue-switcher__label"
  }, [(_vm.label) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.label && _vm.value) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.textEnabled)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.label && !_vm.value) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.textDisabled)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.trigger
    }
  }), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99b15bd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-switches/src/switches.vue
// module id = 1437
// module chunks = 0